@if (hasPermission()) {
  <button
    class="relative flex items-center justify-center"
    [ngClass]="[
      buttonClasses(),
      !label() ? 'min-h-[40px] min-w-[40px] w-[40px] h-[40px] p-0' : 'min-h-[40px] px-4',
    ]"
    [type]="type()"
    [disabled]="isDisabled()"
    (click)="onClick()"
  >
    <span [class.invisible]="loading()" class="flex items-center gap-2 text-[16px]">
      <i *ngIf="icon()" [ngClass]="icon()"></i>
      {{ label() }}
    </span>

    <i *ngIf="loading()" class="absolute fas fa-spinner fa-spin"></i>
  </button>
}
